import '../../../node_modules/icheck/skins/all.css';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/styles/icheck/index.ts